import React from "react";
import classes from "./GradeTable.module.css";
import defaultAvatar from "../../assets/default-avatar.png";
import LinesEllipsis from "react-lines-ellipsis";
import { IsListEmpty } from "../../utilities/CommonMethods";
import FilterDropDown from "../UI/FilterDropDown/FilterDropDown";
import FilterIcon from '../../assets/icons/filter-icon-blue.svg';

export default function GradeTable(props) {
    const data = props.data;
    const columnData = props.columnData;
    return (
        <div className={classes.TableContainer}>
            {IsListEmpty(columnData)
                ? <p className={classes.Message}>Quizzes or Assignments are not available.</p>
                : <div className={classes.FullTableContainer}>
                    <div className={classes.Table2Container}>
                        <table className={classes.TableStyle2}>
                            <thead className={classes.TableHeading}>
                                <tr className={classes.TableRowHeading}>
                                    <th className={[classes.Head1, classes.Head1Width].join(' ')}>
                                        <div className={classes.CenterAlignTh}>
                                            Name
                                            <img src={FilterIcon} onClick={props.onNameFilterClicked} alt={props.tableHead1 + ' filter sort icon'} className={classes.FilterIcon} />
                                            {props.showNameFilterDropdown
                                                ? <div className={classes.Dropdown}>
                                                    <FilterDropDown
                                                        itemList={props.nameDropDownItems}
                                                        dropDownOpen={props.dropDownOpen}
                                                        onDropDownClicked={props.onNameFilterClicked}
                                                        onDropDownItemClicked={props.onDropDownItemClicked}
                                                        activeItem={props.activeNameDropdownItem}
                                                        searchFieldValue={props.nameSearchFieldValue}
                                                        inputChangeHandler={props.nameSearchInputChangeHandler}
                                                        onSearchIconClick={props.onNameSearchIconClick}
                                                        clearSearchResults={props.clearSearchResults}
                                                        searchString={props.searchString}
                                                        forNumber={false}
                                                    />
                                                </div>
                                                : null}
                                        </div>
                                    </th>
                                    <th className={[classes.Head2, classes.Head2Width].join(' ')}>
                                        <div className={[classes.CenterAlignTh, classes.Grade].join(' ')}>
                                            Overall Grade <br />(%)
                                            <img src={FilterIcon} onClick={props.onAttendanceFilterClicked} alt={'Overall Grade filter sort icon'} className={classes.FilterIcon} />
                                            {props.showAttendanceFilterDropdown
                                                ? <div className={[classes.Dropdown, classes.AttendanceDropdown].join(' ')}>
                                                    <FilterDropDown
                                                        itemList={props.attendanceDropDownItems}
                                                        dropDownOpen={props.dropDownOpen}
                                                        onDropDownClicked={props.onAttendanceFilterClicked}
                                                        onDropDownItemClicked={props.onDropDownItemClicked}
                                                        activeItem={props.activeAttendanceDropdownItem}
                                                        searchFieldValue={props.nameSearchFieldValue}
                                                        inputChangeHandler={props.nameSearchInputChangeHandler}
                                                        onSearchIconClick={props.onNameSearchIconClick}
                                                        forNumber={true}
                                                    />
                                                </div>
                                                : null}
                                        </div>
                                    </th>
                                    {IsListEmpty(columnData) ? null :
                                        columnData.slice(0, props.viewAll ? columnData.length : 2).map((item, index) => (
                                            <th key={index} className={[classes.Head3, !props.viewAll && classes.SmallWidth].join(' ')}>
                                                <div className={classes.DueText}>DUE: {item.dueDate}</div>
                                                <div className={classes.TopicTitle} title={item.title}>
                                                    <LinesEllipsis
                                                        text={item.title}
                                                        maxLine='2'
                                                        ellipsis='...'
                                                        trimRight
                                                        basedOn='letters'
                                                    />
                                                    {/* {item.title} */}
                                                </div>
                                                <div className={classes.DescText}>
                                                    <div>
                                                        <div>
                                                            {item.submissions}/{item.totalStudents}
                                                        </div>
                                                        <div className={classes.SubText}>Submissions</div>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            {item.pass}/{item.submissions}
                                                        </div>
                                                        <div className={classes.SubText}>Passed</div>
                                                    </div>
                                                </div>
                                            </th>
                                        ))}
                                </tr>
                            </thead>
                            <thead className={classes.ColumnHeading}>
                                <tr className={classes.SubHeadingRow}>
                                    <th className={classes.Column1}>{props.colHead1}</th>
                                    <th className={classes.Column2}>
                                        <div className={classes.SubHeadingData}>
                                            {`${props.colHead2} %`}
                                        </div>
                                    </th>
                                    {IsListEmpty(columnData) ? null :
                                        columnData.slice(0, props.viewAll ? columnData.length : 2).map((item, index) => (
                                            <th key={index} className={classes.Column3}>{item.colHead}%</th>
                                        ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index} className={classes.TableRow}>
                                        <td className={classes.RowColumn1}>
                                            <img
                                                src={item.profilePic ? item.profilePic : defaultAvatar}
                                                alt="user-profile-pic"
                                                className={classes.ProfilePic}
                                            />
                                            <span>{item.name}</span>
                                        </td>
                                        <td className={classes.RowColumn2}><div className={classes.OverallGrade}>{item.overallGrade} %</div></td>

                                        {
                                            IsListEmpty(item.grades) ? null
                                                : item.grades.slice(0, props.viewAll ? item.grades.length : 2).map((grade, pos) => {
                                                    return (<td
                                                        key={pos}
                                                        className={
                                                            grade.status.toLowerCase() === "turned in"
                                                                ? [classes.RowColumn3, classes.Submitted].join(" ")
                                                                : grade.status.toLowerCase() === "missing"
                                                                    ? [classes.RowColumn3, classes.Missing].join(" ")
                                                                    : grade.status.toLowerCase() === "failed"
                                                                        ? [classes.RowColumn3, classes.Fail].join(" ")
                                                                        : classes.RowColumn3
                                                        }
                                                    >
                                                        {grade.status === "Missing"
                                                            ? grade.status
                                                            : grade.status === "Turned In"
                                                                ? grade.status
                                                                : `${grade.percentage} %`}
                                                    </td>)
                                                })
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>}
        </div >
    );
}
